import { PUBLIC_COMPANIES, TRANSACTIONS_COMPS } from 'pages/Valuations/util/constants';
import { getDefaultCompsApproachForDropdown } from 'pages/ValuationsAllocation/util/getDefaultCompsApproachForDropdown';
import { GetSelectedApproachProps } from './types';

const getSelectedApproach = (props: GetSelectedApproachProps) => {
  const { approaches, approachId } = props;
  if (approaches?.length && !approachId) {
    return getDefaultCompsApproachForDropdown(approaches, [PUBLIC_COMPANIES, TRANSACTIONS_COMPS]);
  }
  const approachIdStr = approachId?.toString();
  return approaches?.find(
    ({ panelId, valuations_approach_gpc, valuations_approach_gpt }) =>
      panelId?.toString() === approachIdStr
      || valuations_approach_gpc?.id?.toString() === approachIdStr
      || valuations_approach_gpt?.id?.toString() === approachIdStr
  );
};

export default getSelectedApproach;
